module.exports = __webpack_public_path__ + "img/us-quotation-popup-pi@3x.6a2dfcf8.png";